import { FormEvent } from 'react';
import { Wine, DrinkFormData } from '../types';

interface DrinkModalProps {
  wine: Wine;
  drinkForm: DrinkFormData;
  setDrinkForm: (form: DrinkFormData) => void;
  onSubmit: (e: FormEvent) => void;
  onClose: () => void;
}

export function DrinkModal({ wine, drinkForm, setDrinkForm, onSubmit, onClose }: DrinkModalProps) {
  const handleQuantityChange = (delta: number) => {
    const newQty = Math.max(1, Math.min(wine.quantity, drinkForm.quantity + delta));
    setDrinkForm({ ...drinkForm, quantity: newQty });
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
    >
      <div 
        className="ios-sheet w-full"
        onClick={e => e.stopPropagation()}
      >
        <div className="ios-sheet-handle" />
        
        {/* Header */}
        <div style={{ 
          padding: '0 20px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--color-wine)',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <h2 className="wine-title" style={{ 
            fontSize: '18px', 
            margin: 0,
            color: 'var(--color-text)'
          }}>
            Drink a Bottle
          </h2>
          <div style={{ width: '50px' }} />
        </div>
        
        {/* Wine Info Card */}
        <div style={{ 
          margin: '0 20px 20px',
          padding: '16px',
          background: 'var(--color-card)',
          borderRadius: '10px'
        }}>
          <p className="wine-title" style={{ 
            fontSize: '17px', 
            color: 'var(--color-text)',
            marginBottom: '4px'
          }}>
            {wine.wine_name} {wine.vintage && wine.vintage}
          </p>
          <p style={{ fontSize: '15px', color: 'var(--color-text-muted)' }}>
            {wine.producer}
          </p>
          <p style={{ 
            fontSize: '13px', 
            color: 'var(--color-text-muted)',
            marginTop: '8px'
          }}>
            {wine.quantity} bottle{wine.quantity > 1 ? 's' : ''} in cellar
          </p>
        </div>

        <form onSubmit={onSubmit} style={{ padding: '0 20px' }}>
          {/* Quantity Selector */}
          <div style={{ marginBottom: '20px' }}>
            <label className="ios-label">How many bottles?</label>
            <div className="quantity-stepper" style={{ justifyContent: 'center', marginTop: '8px' }}>
              <button
                type="button"
                onClick={() => handleQuantityChange(-1)}
                className="quantity-btn"
              >
                −
              </button>
              <span className="wine-title" style={{ 
                fontSize: '32px', 
                color: 'var(--color-wine)',
                width: '50px',
                textAlign: 'center'
              }}>
                {drinkForm.quantity}
              </span>
              <button
                type="button"
                onClick={() => handleQuantityChange(1)}
                className="quantity-btn"
              >
                +
              </button>
            </div>
          </div>

          {/* Date */}
          <div style={{ marginBottom: '16px' }}>
            <label className="ios-label">Date</label>
            <input
              type="date"
              value={drinkForm.date_drank}
              onChange={(e) => setDrinkForm({ ...drinkForm, date_drank: e.target.value })}
              className="ios-input"
              required
            />
          </div>

          {/* Occasion Notes */}
          <div style={{ marginBottom: '16px' }}>
            <label className="ios-label">Occasion (optional)</label>
            <input
              type="text"
              value={drinkForm.occasion_notes}
              onChange={(e) => setDrinkForm({ ...drinkForm, occasion_notes: e.target.value })}
              className="ios-input"
              placeholder="Dinner with friends, anniversary..."
            />
          </div>

          {/* Rating */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '6px'
            }}>
              <label className="ios-label" style={{ margin: 0 }}>Your Rating (1-100)</label>
              {wine.my_rating && (
                <span style={{ fontSize: '12px', color: 'var(--color-text-muted)' }}>
                  Current: {wine.my_rating}
                </span>
              )}
            </div>
            <input
              type="number"
              min="1"
              max="100"
              value={drinkForm.rating}
              onChange={(e) => setDrinkForm({ ...drinkForm, rating: e.target.value })}
              className="ios-input"
              placeholder="Leave blank to keep current"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="ios-btn w-full"
            style={{ 
              background: 'var(--color-success)', 
              color: 'white',
              fontSize: '17px'
            }}
          >
            🍷 Drink {drinkForm.quantity} Bottle{drinkForm.quantity > 1 ? 's' : ''}
          </button>
        </form>
      </div>
    </div>
  );
}
